import React, { Component } from 'react';
import styled from 'styled-components';
import ReCAPTCHA from 'react-google-recaptcha';
import media from 'src/styles/media';

import Input from './elements/Input';
import Select from './elements/Select';
import Radio from './elements/Radio';
import Recaptcha from './elements/Recaptcha';

let isRecaptchaVerify = false;

class Form extends Component {
  constructor(props) {
    super(props);
    this.$form = React.createRef();
    this.$recaptcha = React.createRef();
  }

  handlePhoneInput = (e) => {
    const MAX_SIZE = 10;
    let target = e.target;
    if (target.value.length > MAX_SIZE) {
      target.value = target.value.slice(0, MAX_SIZE);
    }
  };

  handleSubmit = () => {
    this.$recaptcha.current.execute();
  };

  handleClick = (e) => {
    if (!isRecaptchaVerify) {
      e.preventDefault();
      alert('Please verify the Recaptcha. Thank you!');
    }
  };

  render() {
    return (
      <Root
        ref={this.$form}
        id="register"
        action="https://gateway.rennie.com/leads"
        method="POST"
      >
        <input
          type="hidden"
          name="captcha_settings"
          value='{"keyname":"SIXONEEIGHTCARNARVON","fallback":"true","orgId":"00Dj0000000HQIU","ts":""}'
        />
        <Recaptcha />
        <div style={{ position: 'absolute', left: '-9999px', top: '-9999px' }}>
          <label htmlFor="pardot_extra_field">Comments</label>'
          <input
            type="text"
            id="pardot_extra_field"
            name="pardot_extra_field"
          />
        </div>
        <input name="00N3Z00000CeVvt" type="hidden" value="Project Site" />
        <input name="00N3Z00000CeVw9" type="hidden" value="Web Source" />
        
        <input
          name="00N3Z00000CeVw2"
          type="hidden"
          value="7013Z0000033kxTQAQ"
        />
        <input
          name="00N3Z00000CeVw3"
          type="hidden"
          value="a04f100000VSNtlAAH"
        />
        <input name="recordType" type="hidden" value="012j0000000z7Y9" />
        <input name="00N3Z00000CeYiQ" type="hidden" value="1" />
        <input name="00N3Z00000CeVw1" type="hidden" value="Web Registration" />
        {/* <Input
          type="hidden"
          name="retURL"
          value={`${window.location.origin}/thankyou`}
        /> */}
        <input
          name="retURL"
          type="hidden"
          value="https://618carnarvon.com/thankyou"
        />

        <Background />
        <ColumnContainer>
          <Column>
            <h3>Your Details</h3>
            <label htmlFor="first_name">First Name *</label>
            <Input type="text" name="first_name" maxLength="40" required />
            <label htmlFor="last_name">Last Name *</label>
            <Input type="text" name="last_name" maxLength="40" required />
            <label htmlFor="email">Email *</label>
            <Input type="email" name="email" maxLength="80" required />
            <label htmlFor="phone">Phone Number *</label>
            <Input
              type="number"
              name="phone"
              onInput={this.handlePhoneInput}
              required
            />
            <label htmlFor="zip">Postal Code *</label>
            <Input type="text" name="zip" maxLength="20" required short />
          </Column>
          <Column>
            <h3>Your Enquiry</h3>
            <label htmlFor="00Nf100000CBrGQ">
              What bedroom type are you interested in?
            </label>
            <Select
              id="00Nf100000CBrGQ"
              name="00Nf100000CBrGQ"
              title="Bedroom Type Interested"
              defaultValue=""
            >
              <option value="" disabled>
                - Select -
              </option>
              <option value="Studio">Studio</option>
              <option value="1 Bed">1 Bed</option>
              <option value="2 Bed">2 Bed</option>
              <option value="3 Bed">3 Bed</option>
            </Select>

            <Radio
              title="Are you a realtor?*"
              options={['Yes', 'No']}
              id="00Nj0000000gK0N"
              name="00Nj0000000gK0N"
            />

            <Radio
              title="Are you a being represented by a realtor?"
              options={['Yes', 'No']}
              id="00Nj0000000gJzU"
              name="00Nj0000000gJzU"
            />

            <label htmlFor="00Nj000000AITER">How did you hear about us?</label>
            <Select
              id="00Nj000000AITER"
              name="00Nj000000AITER"
              title="How did you hear about us?"
              defaultValue=""
            >
              <option value="" disabled>
                - Select -
              </option>
              <option value="Signage/Walk by/Drive by">
                Signage/Walk by/Drive by
              </option>
              <option value="Realtor">Realtor</option>
              <option value="Online Search">Online Search</option>
            </Select>
          </Column>
        </ColumnContainer>
        <Disclaimer>
          The information you provide will be kept confidential and used only by
          Skyllen Pacific Developments and Rennie to enhance your home buying
          experience and the level of service you receive. The members of our
          Sales Team are all licensed Real Estate Professionals with Rennie and
          therefore are unable to provide representation to potential buyers of
          618 Carnarvon. To learn more about various forms of Realtor
          representation and the choices available to you, please{' '}
          <a
            href="/assets/Disclosure-of-Representation-in-Trading-Services.pdf"
            target="_blank"
          >
            click here.
          </a>
        </Disclaimer>
        <label>Email Opt In: *</label>
        <Consent htmlFor="00Nj0000000kXHD">
          <span>
            Please confirm your consent to receive email communication from
            Skyllen Pacific and Rennie including information about upcoming
            developments, VIP early access and special offers.
          </span>
          <input
            type="checkbox"
            id="00Nj0000000kXHD"
            name="00Nj0000000kXHD"
            value="1"
            required
          />
          <Checkbox />
        </Consent>
        {/* <div
          className="g-recaptcha"
          data-sitekey="6Lf28ZkUAAAAAI3tqWOBY52dxOVVov4CrmJXKbVP"
        /> */}
        <ReCAPTCHA
          sitekey="6LfvYeUUAAAAAHHyyJI52VnD116Bq9NFDrsMetYI"
          size="invisible"
          ref={this.$recaptcha}
          // onChange={this.onChange}
        />
        {/* <div
          className="g-recaptcha"
          data-sitekey="6LfvYeUUAAAAAHHyyJI52VnD116Bq9NFDrsMetYI"
          data-size="invisible"
          data-callback="formSubmit"
        ></div> */}
        <br />
        <div>
          <ButtonSubmit type="submit">Register</ButtonSubmit>
        </div>
      </Root>
    );
  }
}

const Root = styled.form`
  padding: 45px 50px;
  background: #051c2c;
  max-width: 720px;
  margin: 0 auto;
  position: relative;
  @media (max-width: ${media.sm}) {
    width: 100%;
    max-width: 100%;
  }
  h1 {
    margin-bottom: 40px;
  }
  label {
    margin-bottom: 10px;
    display: block;
    color: #fff;
    font-family: 'DINOT';
    text-align: left;
  }
  input[type='checkbox'] {
    opacity: 0;
    min-width: 16px;
    height: 16px;
    pointer-events: none;
    background: #fff;
    position: absolute;
    top: 8px;
    left: 2px;
    &:checked + div {
      &:after {
        opacity: 1;
      }
    }
  }
  &::before,
  &::after {
    content: '';
    position: absolute;
    height: 125px;
    width: 47.5vw;
    max-width: 500px;
    background: ${(props) => props.theme.colorPrimary};
    opacity: 0.7;
    z-index: -10;
    display: none;
  }
  &::before {
    top: 80%;
    right: 50%;
  }
  &::after {
    top: 34%;
    left: 50%;
    @media (max-width: 1079px) {
      top: 49.5%;
    }
  }
  .g-recaptcha {
    margin-bottom: 40px;
  }
`;

const ColumnContainer = styled.div`
  display: flex;
  justify-content: space-between;
  @media (max-width: 750px) {
    display: block;
  }
`;

const Column = styled.div`
  width: 47.5%;
  text-align: left;
  @media (max-width: 750px) {
    width: 100%;
  }
  h3 {
    color: #fff;
    font-family: ${({ theme }) => theme.fontHeader};
    font-weight: 500;
    font-size: 18px;
    letter-spacing: 1px;
    margin-bottom: 20px;
  }
`;

const Background = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: ${(props) => props.theme.colorSecondary};
  z-index: -1;
`;

const Consent = styled.label`
  display: flex !important;
  margin-bottom: 20px !important;
  position: relative;
  span {
    order: 10;
  }
`;

const Checkbox = styled.div`
  min-width: 16px;
  height: 16px;
  position: relative;
  margin-right: 15px;
  margin-top: 5px;
  border: 1px solid #fff;
  order: -1;
  &::after {
    content: '';
    display: block;
    width: 50%;
    height: 50%;
    background: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: 0;
    transition: all 0.25s;
  }
`;

const Disclaimer = styled.p`
  font-family: ${({ theme }) => theme.fontHeader};
  text-align: left;
  color: white;
  margin-bottom: 20px;
`;

const ButtonSubmit = styled.button`
  margin-top: 40px;
  background-color: transparent;
  border: 1px solid ${({ theme }) => theme.colorPrimary};
  width: 176px;
  height: 61px;
  text-transform: uppercase;
  font-family: ${({ theme }) => theme.fontHeader};
  font-size: 18px;
  pointer-events: auto;
  opacity: 1;
`;
export default Form;



// WEBPACK FOOTER //
// ./src/pages/Register/elements/Form/Form.js